// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__RbCuB","header":"Messages_header__1Bp_k"};